import React, { useEffect, useMemo } from "react";

import { page } from "../../../assets/bases/page";
import { HttpError } from "../../../elements/HttpError/HttpError";

import "./LoginFailed.scss";

const errorPhrases = Object.freeze({
    init:["oauthFailInitCaption", "oauthFailInitDesc"],
    magicExpired:["oauthFailMagicExpiredCaption", "oauthFailMagicExpiredDesc"],
    magicUsed:["oauthFailMagicUsedCaption", "oauthFailMagicUsedDesc"],
    provider:["oauthFailProviderCaption", "oauthFailProviderDesc"]
});

const getErrorType = errorCode=>{
    const code = Number(errorCode);
    if (code === 218) { return "magicExpired"; }
    if (code === 219) { return "magicUsed"; }
    if (code >= 100 && code < 200) { return "init"; }
    return "provider";
};

export const LoginFailed = _=>{
    const { errorCode, errorMessage } = useMemo(_=>page.get("search") || {}, []);
    const [ caption, desc ] = errorPhrases[getErrorType(errorCode)];

    useEffect(()=>{
        if (!errorCode && !errorMessage) { return; }
        console.warn("OAuth login failed", { errorCode, errorMessage });
    }, [errorCode, errorMessage]);

    return (
        <HttpError
            caption={caption}
            className="LoginFailed"
            desc={desc}
            status="401"
        />
    );
};
